import React, { useState } from 'react';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import {
  AddButton,
  CancelButton,
  EditButton,
  SubmitButton,
  UpdateButton,
} from '../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, LinearProgress, Stack, TextField } from '@mui/material';
import GlobalSelectField from '../../../components/mui/GlobalSelectField';
import { useDispatch, useSelector } from 'react-redux';
import { addProspectLead, getProspectLeadsTable, updateProspectLead } from '../../../redux/features/globalSlice';
import useHandleApiResponse from '../../../Hooks/useHandleApiResponse';
import { prospect_leads_departments } from '../../../utils/constants/departmentDetails';

export const statusOptions = [
  { id: 1, name: 'Call Attended' },
  { id: 2, name: 'Admission Done' },
  { id: 3, name: 'Assessment Done' },
];

export const genders = [
  { id: 1, name: 'Male' },
  { id: 2, name: 'Female' },
];

export const assignOptions = [
  { id: 'ALL', name: 'ALL' },
  { id: 'CSD', name: 'CSD' },
  { id: 'OGD', name: 'OGD' },
];

const ProspectLeadAddEdit = ({ row, onClose }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.global);
  const [open, setOpen] = useState(false);
  const handleApiResponse = useHandleApiResponse();
  const initialValues = {
    name: row ? row.name : '',
    // age: row ? row.age : '',
    // place: row ? row.place : '',
    email: row ? row.email : '',
    phone_number: row?.phone ?? '',
    country_code: row?.country_code ?? '91',
    // gender: row ? (row.gender === 'Male' ? 1 : 2) : '',
    department_id: row?.current_department_id ?? '',
    // status: row?.current_status_id ?? '',
  };

  const schema = Yup.object({
    name: Yup.string().required('Name is required'),
    // age: Yup.number().required('Age is required'),
    // place: Yup.string().required('Place is required'),
    email: Yup.string().email('Invalid email format').nullable().notRequired(),
    phone_number: Yup.number().required('Contact number is required'),
    // gender: Yup.mixed().required('Gender is required'),
    country_code: Yup.string().required('Country code is required'),
    department_id: Yup.number().required('Department is required'),
    // status: Yup.mixed().required('Status is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      const payload = {
        name: values.name,
        // email: values.email,
        email: values.email ? values.email : null,
        phone: values.phone_number,
        country_code: values.country_code,
        current_department_id: values.department_id,
      };

      let res;

      if (row) {
        // UPDATE
        res = await dispatch(
          updateProspectLead({
            id: row.prospect_lead_id,
            data: payload,
          }),
        );
      } else {
        // ADD
        res = await dispatch(addProspectLead([payload]));
      }

      // if (res.meta.requestStatus === 'fulfilled') {
      //   formik.resetForm();

      handleApiResponse(res, {
        onSuccess: () => {
          formik.resetForm();

          if (onClose) onClose(true);
        },
        onFailed: () => {
          console.log('Add/Update Failed');
        },
      });
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    if (onClose) onClose(false);
  };

  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            id="name"
            label="Name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
          {/*
                  <TextField
                    fullWidth
                    type="number"
                    id="age"
                    label="Age"
                    name="age"
                    value={formik.values.age}
                    onChange={formik.handleChange}
                    error={formik.touched.age && Boolean(formik.errors.age)}
                    helperText={formik.touched.age && formik.errors.age}
                    onWheel={(e) => e.target.blur()}
                  /> */}

          {/* <TextField
                    fullWidth
                    id="place"
                    label="Place"
                    name="place"
                    value={formik.values.place}
                    onChange={formik.handleChange}
                    error={formik.touched.place && Boolean(formik.errors.place)}
                    helperText={formik.touched.place && formik.errors.place}
                  /> */}
          <TextField
            fullWidth
            type="email"
            id="email"
            label="Email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <Stack direction="row" spacing={1}>
            <TextField
              fullWidth
              id="country_code"
              label="Country Code"
              name="country_code"
              value={formik.values.country_code}
              onChange={formik.handleChange}
              error={formik.touched.country_code && Boolean(formik.errors.country_code)}
              helperText={formik.touched.country_code && formik.errors.country_code}
            />
            <TextField
              fullWidth
              type="number"
              id="phone_number"
              label="Contact Number"
              name="phone_number"
              value={formik.values.phone_number}
              onChange={formik.handleChange}
              error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
              helperText={formik.touched.phone_number && formik.errors.phone_number}
              onWheel={(e) => e.target.blur()}
            />
          </Stack>
          <GlobalSelectField
            options={{
              formik,
              label: 'Assigned to Department',
              name: 'department_id',
              data: prospect_leads_departments,
              keys: { id: 'id', value: 'name' },
            }}
            disabled={Boolean(row)}
          />
          {/*
                  <GlobalSelectField
                    options={{
                      formik,
                      label: 'Gender',
                      name: 'gender',
                      data: genders,
                      keys: { id: 'id', value: 'name' },
                    }}
                  /> */}

          {/* <GlobalSelectField
            options={{
              formik,
              label: 'Status',
              name: 'status',
              data: statusOptions,
              keys: { id: 'id', value: 'name' },
            }}
          /> */}
          {/* Buttons */}
          {loading && (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Stack direction={'row'} spacing={1}>
              <CancelButton action={handleCancel}>Cancel</CancelButton>

              {row ? (
                <UpdateButton disabled={loading} type="submit">
                  {loading ? 'Updating...' : 'Update'}
                </UpdateButton>
              ) : (
                <SubmitButton disabled={loading} type="submit">
                  {loading ? 'Submitting...' : 'Submit'}
                </SubmitButton>
              )}
            </Stack>
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
};

export default ProspectLeadAddEdit;
